import { Box, BoxProps } from '@chakra-ui/react';

import { trackEvent } from '~/features/analytics/track-event';
import { CatalogCardCarouselLegacy } from '~/features/catalog/components/catalog-card-carousel.legacy';
import { CatalogItem } from '~/features/catalog/models/catalog-item';
import { getUserTypeCookie } from '~/features/cookies/utils/get-user-type-cookie';
import { useUserExperience } from '~/features/user/hooks/use-user-experience';
import { useClientRender } from '~/hooks/use-client-render';
import { useI18n } from '~/hooks/use-i18n';

export function RelatedProgramsSection({
  programKey,
  title,
  carouselTheme = 'light',
  containerProps,
  relatedPrograms,
}: {
  programKey?: string;
  title?: string;
  carouselTheme?: 'light' | 'dark';
  containerProps?: BoxProps;
  relatedPrograms?: CatalogItem[];
}) {
  const { t } = useI18n();
  const { userExperience, userExperienceIsLoading } = useUserExperience();
  const clientRender = useClientRender();
  const isEnterpriseUser = clientRender && getUserTypeCookie() === 'enterprise';
  const sectionTitle = title ? title : t('program.relatedPrograms');

  if ((!userExperienceIsLoading && userExperience?.hasFocused) || isEnterpriseUser || !clientRender) return null;

  return (
    <Box as='section' bgColor='accent.sky.100' overflow='hidden' py='40px' {...containerProps}>
      <CatalogCardCarouselLegacy
        carouselTheme={carouselTheme}
        catalogItems={relatedPrograms}
        title={sectionTitle}
        titleAs='h2'
        titleSize='h3'
        onCardClick={(catalogItem) =>
          trackEvent({
            type: 'click',
            label: 'related_programs_clicked',
            name: 'Product Page CTA Clicked',
            value: catalogItem.title!,
            additionalAttributes: {
              product_ids: [programKey].filter(Boolean),
            },
          })
        }
      />
    </Box>
  );
}
